import { useEffect, useRef, useState } from "react";

/**
 * Returns [ref, inView] — sets inView=true the first time the element
 * intersects the viewport. Stable: no extra re-renders after that.
 */
export const useInView = (threshold = 0.2) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return undefined;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setInView(true);
            },
            { threshold }
        );
        obs.observe(node);
        return () => obs.disconnect();
    }, [threshold]);

    return [ref, inView];
};
